import uiConfig from 'src/lib/ui/config';
import { View } from '@play-co/timestep-core/ui';
import ResponsiveScene from './ResponsiveScene';
import { Transition } from 'src/game/logic/SceneManager';
import { user } from 'src/StateObserver';
import ToiletRoomDecorationView from '../decoration/ToiletRoomDecorationView';
import {
  DecorationItem,
  DecorationSlot,
} from 'src/replicant/decoration/decoration.ruleset';
import { getFriendsPet, getPet } from '../pet';
import * as Visit from 'src/replicant/visit';
import { AssetGroup } from '@play-co/timestep-core';

export default class ToiletRoomScene extends ResponsiveScene {
  private decorationsView: ToiletRoomDecorationView;

  constructor() {
    super(new View({ width: uiConfig.width, height: uiConfig.height }));

    this.decorationsView = new ToiletRoomDecorationView({
      autoDecorationUpdate: false,
    });

    this.getView().addSubview(this.decorationsView);

    this.getView().tag = 'toilet';
  }

  public async preload() {
    await new AssetGroup(
      AssetGroup.constructURLs(['assets/ui/toilet/']),
    ).load();
  }

  /**
   * Called before scene show
   */
  public prepareScene() {
    // Show friend room decorations
    const isVisiting = Visit.getters.isVisiting(user());

    // Clear all previous
    this.decorationsView.clear();

    // Try to get decorations
    const decorations: Map<DecorationSlot, DecorationItem> | undefined =
      isVisiting
        ? getFriendsPet()?.getRoomDecoration('toilet')
        : getPet().getRoomDecoration('toilet');

    // Set friends decorations assets
    this.decorationsView.updateSelectedItems(
      decorations ?? new Map(),
      'classic',
    );
  }

  public transition(): Transition {
    return 'slide_forward';
  }
}
